import React from 'react';
import { useLocation, useNavigate, Link } from 'react-router-dom';

export function EmailSentPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const email = location.state?.email || 'your email';

  return (
    <div className="email-sent-page">
      <div className="email-sent-container">
        <div className="email-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="64"
            height="64"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <rect width="20" height="16" x="2" y="4" rx="2" />
            <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
          </svg>
        </div>

        <h1>Check your email</h1>

        <p className="email-sent-message">
          We've sent a magic link to <strong>{email}</strong>
        </p>

        <p className="email-sent-instructions">
          Click the link in the email to sign in. The link will expire in 1 hour.
        </p>

        <div className="email-sent-actions">
          <Link to="/login" className="back-link">
            ← Back to login
          </Link>
        </div>

        <p className="email-sent-help">
          Didn't receive the email? Check your spam folder or{' '}
          <button onClick={() => navigate('/login')} className="resend-link">
            try again
          </button>
        </p>
      </div>
    </div>
  );
}
